<template>
    <div class="somaticTree-container-mobile">
        <div class="somatic-header">
            <button class="close-mobile" @click="dialog">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                    <path d="M6 5L18.7279 17.7279" stroke="#4854FE" stroke-width="2" stroke-linecap="round" />
                    <path d="M6 18L18.7279 5.27208" stroke="#4854FE" stroke-width="2" stroke-linecap="round" />
                </svg>
            </button>
            <h1 class="main-title">Показатели психических функций</h1>
            <div class="div-btn">
                <button @click="dialog" class="btn-list">К списку систем организма</button>
            </div>
        </div>

        <div class="somaticTree-body" style="height: calc(100vh - 217px);">
            <div class="main-body-age">
                <div class="body_age" @click="isOpen = !isOpen">
                    <div class="div-filters">
                        <div>
                        <span>Возраст</span>
                        <span v-if="isOpen">: {{ ageOnMonth }} мес</span>
                        </div>
                        <v-icon>
                            {{ 'mdi-chevron-down' }}
                        </v-icon>
                    </div>
                </div>
                <v-expand-transition>
                    <div v-show="isOpen" class="age-top">
                        <v-slider class="slider-thumbs-custom" :class="{ 'female': sex, 'male': !sex }" :min="1"
                            :max="count" style="margin-bottom: 32px;" v-model="ageOnMonth" :tick-labels="tickLabelsSlider"
                            step="1" thumb-label="always" :thumb-size="34" :color="sex ? '#E882DD' : '#717BF9'"
                            :track-color="sex ? '#E882DD' : '#717BF9'">
                            <template v-slot:thumb-label></template>
                        </v-slider>

                        <div class="age-wrap">
                            <div class="age_switch-container">
                                <p :class="{ 'male': !sex }">M</p>
                                <v-switch v-model="sex" color="#E882DD">
                                </v-switch>
                                <p :class="{ 'female': sex }">Ж</p>
                            </div>

                            <div class="age_switch-container">
                                <p
                                    :class="{ 'male': !switchBeforeOrAfterOne && !sex, 'female': !switchBeforeOrAfterOne && sex }">
                                    До года</p>
                                <v-switch class="switch-custom" v-model="switchBeforeOrAfterOne" @change="changeAge"
                                    :color="sex ? '#E882DD' : '#717BF9'" :class="{ 'female': sex, 'male': !sex }">
                                </v-switch>
                                <p
                                    :class="{ 'male': switchBeforeOrAfterOne && !sex, 'female': switchBeforeOrAfterOne && sex }">
                                    После 1 года</p>
                            </div>
                            <div class="body-img">
                                <v-card-text>
                                    <humanImage :ageOnMonth="ageOnMonth" :gender="sex" :activeName="activeName"
                                        :switchBeforeOrAfterOne="!switchBeforeOrAfterOne"
                                        :dialogSomaticName="dialogSomaticName" :heightOffset="386" style="height: 300px;" />
                                </v-card-text>
                            </div>
                        </div>

                    </div>
                </v-expand-transition>
            </div>

            <div class="body-info">
                <div class="body-text">
                    <v-card-text class="py-0 my-0">
                        <v-card class="mx-auto" flat :key="items[0].name">
                            <v-row>
                                <v-col cols="12" md="8">
                                    <div v-for="(selection, i) in filterProperties(items, switchBeforeOrAfterOne ? ageOnMonth * 12 * 30 : ageOnMonth * 30)"
                                        :key="'A' + i">
                                        <h2>{{ i }}</h2>
                                        <ul>
                                            <li v-for="(item, key) in selection" :key="'B' + key">
                                                <span class="text-item">
                                                    {{ item.name }}, {{ item.value }}
                                                </span>
                                            </li>
                                        </ul>
                                    </div>
                                </v-col>
                            </v-row>
                        </v-card>
                    </v-card-text>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import './index.scss'
import humanImage from "../../Student/HumanImage.vue";
export default {
    components: { humanImage },
    name: 'MentalFunctions',
    props: {
        treeListM: { type: Array, default: () => [] },
        treeListJ: { type: Array, default: () => [] }
    },
    data() {
        return {
            tickLabelsSlider: [1, '', '', '', '', 6, '', '', '', '', '', 12],
            count: 12,
            switchBeforeOrAfterOne: false,
            dialogSomaticName: null,
            ageOnMonth: 1,
            clientH: 688,
            selectedItem: null,
            clickShow: true,
            sex: false,
            isOpen: false,
            width: 0,
            items: [],
            activeName: 'Система психических функций',
            tapLevel1index: null,
        }
    },
    watch: {
        sex(val) {
            if (val) {
                this.items = this.treeListJ
            }
            if (!val) {
                this.items = this.treeListM
            }
            // console.log(this.isOpen);
        }
    },
    methods: {
        setActive(ev, i) {
            const w = ev.target.getBoundingClientRect().left - (this.$refs.ageTxt.getBoundingClientRect().right + 20)
            this.width = w
            this.ageOnMonth = i + 1
        },
        dialog() {
            this.$emit('dialog', {})
        },
        filterProperties(array, ageOnDay) {
            let res = [];

            for (let i = 0; i < array.length; i++) {
                for (let j = 0; j < array[i].properties.length; j++) {

                    let left = 0, right = array[i].properties[j].ageValues.length - 1;

                    while (left <= right) {
                        let middle = Math.floor((left + right) / 2), currentIteration = array[i].properties[j].ageValues[middle];

                        if (currentIteration.ageOnDay < ageOnDay) {
                            left = middle + 1;
                        } else if (currentIteration.ageOnDay > ageOnDay) {
                            right = middle - 1;
                        } else {
                            left = middle
                            break;
                        }
                    }

                    if (array[i].properties[j].ageValues[left] && array[i].properties[j].ageValues[left].ageOnDay == ageOnDay) {
                        res.push({
                            groupName: array[i].name,
                            name: array[i].properties[j].name,
                            value: this.returnResult(array[i].properties[j].ageValues[left])
                        })
                    } else if (array[i].properties[j].ageValues[left - 1] && array[i].properties[j].ageValues[left - 1].ageOnDay < ageOnDay) {
                        res.push({
                            groupName: array[i].name,
                            name: array[i].properties[j].name,
                            value: this.returnResult(array[i].properties[j].ageValues[left - 1])
                        })
                    }
                }
            }

            return res.reduce((group, product) => {
                const { groupName } = product;
                group[groupName] = group[groupName] ?? [];
                group[groupName].push(product);

                return group;
            }, {})
        },
        returnResult(obj) {
            let res = '';

            if (obj.valueType == 0) {
                if (obj.valueTo) {
                    res = `${obj.measurementName ? obj.measurementName + ': ' : ''}${obj.valueFrom}-${obj.valueTo}`
                } else {
                    res = `${obj.measurementName ? obj.measurementName + ': От ' : ''}${obj.valueFrom}`
                }
            } else if (obj.valueType == 1) {
                res = obj.valueText
            }

            return res
        },
        changeAge(flag) {
            this.ageOnMonth = 1;
            if (!flag) {
                this.count = 12
                this.tickLabelsSlider = [1, '', '', '', '', 6, '', '', '', '', '', 12]

                return;
            }

            this.count = 18
            this.tickLabelsSlider = [1, '', '', '', '', 6, '', '', '', '', '', 12, '', '', '', '', '', 18]
        }
    },
    created() {
        this.items = this.treeListM
        this.clientH = window.innerHeight;
    }
}
</script>

